import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ProDriverFilterItem = ResultOf<
  typeof proDriverFilterQuery
>["proDrivers"]["data"][number];

export const proDriverFilterQuery = graphql(`
  query ProDriverFilter($first: Int!, $page: Int, $search: String) {
    proDrivers(first: $first, page: $page, search: $search) {
      data {
        id
        name
        email
      }
    }
  }
`);
